<template>

  <div id="rolePermissions">

    <div class="subtitle">Ticket Permissions</div>

    <v-radio-group :mandatory="true" v-model="permissions.tickets.value">
      <v-radio class="radio-buttons" v-for="(perm, key) in permissions.tickets.options" v-if="accessLevel >= perm.accessLevel" color="primary" :value="key" :key="key">
        <div class="label-section" slot="label">
          <div class="name">{{ perm.name }}</div>
          <div class="desc">{{ perm.description }}</div>
        </div>
      </v-radio>
    </v-radio-group>

    <template v-if="accessLevel >= 2">
      <div class="subtitle">User Permissions</div>

      <v-radio-group :mandatory="true" v-model="permissions.user.value">
        <v-radio class="radio-buttons" v-for="(perm, key) in permissions.user.options" color="primary" :value="key" :key="key">
          <div class="label-section" slot="label">
            <div class="name">{{ perm.name }}</div>
            <div class="desc">{{ perm.description }}</div>
          </div>
        </v-radio>
      </v-radio-group>


      <div class="subtitle">Other Permissions</div>

      <v-checkbox class="checkboxes" hide-details v-for="(perm, key) in permissions.other.options" v-if="accessLevel >= perm.accessLevel" v-model="permissions.other.value" color="primary" :value="key" :key="key">
        <div class="label-section" slot="label">
          <div class="name">{{ perm.name }}</div>
          <div class="desc">{{ perm.description }}</div>
        </div>
      </v-checkbox>
    </template>
  </div>

</template>

<script>

  export default {
    data () {
      return {
        permissions: {
          tickets: {
            accessLevel: 1,
            value: '0',
            options: {
              '0': {
                name: 'None',
                description: 'No ticket access.',
                accessLevel: 1
              },
              '1': {
                name: 'Ticket Creator',
                description: 'User can create tickets and ticket comments.',
                accessLevel: 1
              },
              '2': {
                name: 'Ticket Manager',
                description: 'User can create and update tickets, ticket notes, and ticket comments. User can also be assigned to tickets.',
                accessLevel: 2
              },
              '3': {
                name: 'Ticket Admin',
                description: 'User can create and update tickets, ticket notes, and ticket comments. User can also access all tickets, whether or not they have been assigned.',
                accessLevel: 2
              }
            }
          },
          user: {
            accessLevel: 2,
            value: 0,
            options: {
              '0': {
                name: 'None',
                description: 'No user access.',
                accessLevel: 2
              },
              '1': {
                name: 'Users',
                accessLevel: 2
              },
              '2': {
                name: 'Users and Invites',
                accessLevel: 2
              }
            }
          },
          other: {
            value: [],
            options: {
              unit: {
                name: 'Unit',
                description: 'User can create, update, and delete units and unit types.',
                accessLevel: 2
              },
              ticketTags: {
                name: 'Ticket Tag',
                description: 'User can create, update, and delete ticket tags.',
                accessLevel: 3
              },
              property: {
                name: 'Property',
                description: 'User can update properties.',
                accessLevel: 3
              },
              roles: {
                name: 'Roles',
                description: 'User can create, update, and delete role templates, as well as update roles on all users.',
                accessLevel: 3
              }
            }
          }
        }
      }
    },
    props: {
      accessLevel: {
        type: Number
      }
    },
    methods: {
      updatePermissions () {

        // Set up radio button contexts based on this role
        this.permissions.user.options['1'].description = 'User can see a list of other users and their roles for ' + (this.accessLevel === 2 ? 'this property.' : 'the company.');
        this.permissions.user.options['2'].description = 'User can see a list of other users and their roles, as well as invite other users ' + (this.accessLevel === 2 ? 'to this property.' : 'to the company.')
        
        this.permissions.tickets.value  = '0';
        this.permissions.user.value     = '0';
        this.permissions.other.value    = [];
      },

      init (permissions) {
        
        console.log('PERMISSIONS:', permissions);

        this.$nextTick(() =>{

          if      (permissions.ticketAdmin)    this.permissions.tickets.value = '3'; 
          else if (permissions.ticketManager)  this.permissions.tickets.value = '2'; 
          else if (permissions.ticket)         this.permissions.tickets.value = '1';
          else                                 this.permissions.tickets.value = '0'; 
  
          if      (permissions.invite)         this.permissions.user.value = '2'; 
          else if (permissions.user)           this.permissions.user.value = '1'; 
          else                                 this.permissions.user.value = '0';
  
          var other = [];
          if (permissions.unit)                 other.push('unit'); 
          if (permissions.property)             other.push('property'); 
          if (permissions.role)                 other.push('roles'); 
          if (permissions.ticketType)           other.push('ticketTags'); 
  
          this.permissions.other.value = other;
        });
      }
    },
    watch: {
      accessLevel () {
        this.updatePermissions();
      }
    },
    computed: {
      value () {
        
        return {
          ticket        : Number(this.permissions.tickets.value) >= 1,
          ticketManager : Number(this.permissions.tickets.value) >= 2,
          ticketAdmin   : Number(this.permissions.tickets.value) >= 3,
          user          : Number(this.permissions.user.value) >= 1,
          invite        : Number(this.permissions.user.value) >= 2,
          unit          : this.permissions.other.value.includes('unit'),
          property      : this.permissions.other.value.includes('property'),
          role          : this.permissions.other.value.includes('roles'),
          ticketType    : this.permissions.other.value.includes('ticketTags')
        };
          
      }
    },
    created () {
      this.updatePermissions();
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #rolePermissions {

    position: relative;

    .subtitle {
      @include fontPrimary500();
      @include title();
      font-size: 12px;
      margin: 16px 0 0;
    }

    .radio-buttons,
    .checkboxes { 
      
      margin: 16px 0;
      
      label {
        position: relative !important;
        height: auto !important;
        white-space: normal;
      }

      .input-group__input {
        min-height: 0 !important;
        position: absolute;
        left: 0px;
      }

      .input-group--selection-controls__ripple {
        transform: translate(-12px,-21%);
      }

      .input-group__input .icon--selection-control {
        top: 45%;
      }

      .label-section {
        
        .name {
          color: $black87;
          line-height: auto;
          height: auto;
          margin-left: 16px;
          line-height: 16px !important;
        }

        .desc {
          color: $black54;
          font-size: 12px;
          margin: 2px 0 0 16px;
          line-height: 20px !important;
        }

      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/RolePermissions.vue